const addTextAreaCounter = () => {
  document.addEventListener('DOMContentLoaded', () => {

    function updateConcernsRemainingCharCount() {
      try {
        text_area = document.getElementById('complaint_concerns');
        text_length = text_area.value.length;
        remaining_characters = text_area.maxLength - text_length;

        output_span = document.getElementById('complaint_concerns_remaining_characters');
        if (output_span != null) {
          output_span.textContent = "" + remaining_characters;
        }
      } catch(err) {
        console.log("complaint_concerns is not ready yet.");
      }
    }

    document.getElementById('complaint_concerns').onkeyup = function () {
      updateConcernsRemainingCharCount();

    };

    updateConcernsRemainingCharCount();
  });
}

if ($('form#new_complaint').length && $('#complaint_concerns_remaining_characters').length) {
  addTextAreaCounter();
}